import Content, { ContentNS } from "content/content";
import { PageAnalyticsParams } from "features/document-capture/scan-handlers/handleCapturedDocumentScan";
import { ChecklistItemType } from "models/checklist/checklist-item/checklist-item-type";
import { PassportFieldName } from "models/documents/international-passport";
import AnalyticsService from "services/analytics/analytics";
import { PassportFormValues } from "store/slices/passport-slice";

const validateForm = (
  values: PassportFormValues,
  setError: (field: PassportFieldName, error: string) => void,
  params: PageAnalyticsParams
) => {
  const text = (s: string) => Content.shared.t(s, { ns: ContentNS.passport });

  let isFormValid = true;
  let missingFieldsCount = 0;

  if (values.number.length === 0) {
    isFormValid = false;
    setError(PassportFieldName.number, text("error.field-required"));
    missingFieldsCount += 1;
  }

  if (values.givenName.length === 0) {
    isFormValid = false;
    setError(PassportFieldName.givenName, text("error.field-required"));
    missingFieldsCount += 1;
  }

  if (values.surname.length === 0) {
    isFormValid = false;
    setError(PassportFieldName.surname, text("error.field-required"));
    missingFieldsCount += 1;
  }

  if (values.countryCode.length === 0) {
    isFormValid = false;
    setError(PassportFieldName.countryCode, text("error.field-required"));
    missingFieldsCount += 1;
  }

  if (values.nationality.length === 0) {
    isFormValid = false;
    setError(PassportFieldName.nationality, text("error.field-required"));
    missingFieldsCount += 1;
  }

  if (values.birthdate.length === 0) {
    isFormValid = false;
    setError(PassportFieldName.birthdate, text("error.field-required"));
    missingFieldsCount += 1;
  }

  if (values.expiryDate.length === 0) {
    isFormValid = false;
    setError(PassportFieldName.expiryDate, text("error.field-required"));
    missingFieldsCount += 1;
  }

  if (values.gender.length === 0) {
    isFormValid = false;
    setError(PassportFieldName.gender, text("error.field-required"));
    missingFieldsCount += 1;
  }

  if (!isFormValid) {
    AnalyticsService.shared.trackEvent(
      "form_validation_error",
      {
        item_type: ChecklistItemType.TravelDoc,
        missing_fields_number: missingFieldsCount,
        page_path: params.path,
        content_group: params.path,
        page_title: params.title,
        page_location: params.location,
      },
      false // isScanRelated
    );
  }

  return isFormValid;
};

export default validateForm;
